"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.types = void 0;
/* eslint-disable default-param-last */
//  const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
let secureStorage = null;
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
exports.types = {
    /* CONTEXT */
    SET_CONTEXT_DATA: 'MAIN/SET_CONTEXT_DATA',
    SET_CUSTO_PARAMS: 'MAIN/SET_CUSTO_PARAMS',
    SET_CP_PARAMS: 'MAIN/SET_CP_PARAMS',
    SET_ZONE_REFRESH_FLAG: 'MAIN/SET_ZONE_REFRESH_FLAG',
    SET_CP_MODAL_CLOSED: 'MAIN/SET_CP_MODAL_CLOSED',
    CHECK_CP_AND_SET_ZONES: 'MAIN/CHECK_CP_AND_SET_ZONES',
    SET_CHECKED_CP_BY_API: 'MAIN/SET_CHECKED_CP_BY_API',
    /* EDIT MODE */
    SET_EDIT_MODE: 'MAIN/SET_EDIT_MODE',
    /* CLIENT SUBSCRIPTIONS */
    SET_USER_PQ_INFO: 'MAIN/SET_USER_PQ_INFO',
    SET_USER_PO_INFO: 'MAIN/SET_USER_PO_INFO',
    SET_USER_LG_INFO: 'MAIN/SET_USER_LG_INFO',
    SET_USER_RECOM: 'MAIN/SET_USER_RECOM',
    SET_USER_COMPATIBILITIES: 'MAIN/SET_USER_COMPATIBILITIES',
    SET_USER_BUNDLE: 'MAIN/SET_USER_BUNDLE',
    SET_USER_DEFINITION: 'MAIN/SET_USER_DEFINITION',
    /* CAMPAING AND SEND C2C */
    SET_SEND_C2C: 'MAIN/SET_SEND_C2C',
    SET_CAMPAIGN_C2C: 'MAIN/SET_CAMPAIGN_C2C',
};
exports.actions = {
    setCpModalClosed: (flag) => ({ type: exports.types.SET_CP_MODAL_CLOSED, flag }),
    setZoneRefreshFlag: (flag) => ({ type: exports.types.SET_ZONE_REFRESH_FLAG, flag }),
    setCpParams: (data) => ({ type: exports.types.SET_CP_PARAMS, data }),
    setContextData: (data) => ({ type: exports.types.SET_CONTEXT_DATA, payload: data }),
    checkCPAndSetZones: (data) => ({ type: exports.types.CHECK_CP_AND_SET_ZONES, data }),
    setCheckedCPByApi: (flag) => ({ type: exports.types.SET_CHECKED_CP_BY_API, flag }),
    /* EDIT MODE */
    setEditMode: flag => ({ type: exports.types.SET_EDIT_MODE, flag }),
    /* subscriptions */
    setUserPqInfo: (data) => ({ type: exports.types.SET_USER_PQ_INFO, data }),
    setUserPoInfo: (data) => ({ type: exports.types.SET_USER_PO_INFO, data }),
    setUserLgInfo: (data) => ({ type: exports.types.SET_USER_LG_INFO, data }),
    setUserRecom: (data) => ({ type: exports.types.SET_USER_RECOM, data }),
    setUserCompatibilities: (data) => ({ type: exports.types.SET_USER_COMPATIBILITIES, data }),
    setUserBundle: (data) => ({ type: exports.types.SET_USER_BUNDLE, data }),
    setUserDefinition: (data) => ({ type: exports.types.SET_USER_DEFINITION, data }),
    setSendC2C: (data) => ({ type: exports.types.SET_SEND_C2C, data }),
    setCampaignC2C: (data) => ({ type: exports.types.SET_CAMPAIGN_C2C, data }),
};
let context = {};
try {
    context = `${process.env.NEXT_PUBLIC_CONTEXT || '{}'}`;
    // console.log('context antes', context);
    context = JSON.parse(context);
}
catch (err) {
    // console.log('context petó', context)
    console.error(err);
}
const initialState = {
    cp: "...",
    zone: "",
    x: "",
    mobile: 'undefined',
    refreshZone: false,
    cpModalClosed: true,
    // municipio seleccionado, por cliente
    municipio: "",
    // lista de posibles municipios bajo ese cp
    municipiosPosibles: null,
    context,
    logged: 0,
    checkedCpByApi: true,
    editMode: false,
    /* user subscriptions */
    userPq: null,
    userPo: null,
    userFlags: null,
    userLg: null,
    userRecom: null,
    userCompatibilities: null,
    userBundle: null,
    userDefinitions: null,
    c2cState: null,
    campaignState: null,
    campaignInfo: null,
};
function reducer(state = Object.assign({}, initialState), action) {
    switch (action.type) {
        case HYDRATE: {
            let { main } = action.payload;
            return Object.assign(Object.assign({}, state), main);
        }
        case exports.types.SET_CHECKED_CP_BY_API:
            return Object.assign(Object.assign({}, state), { checkedCpByApi: action.flag });
        // solo guardo, jamás deduzco nada
        case exports.types.SET_CP_PARAMS: {
            if (!secureStorage) {
                secureStorage = new utils_secure_local_storage_1.default();
            }
            let currentPersisted = secureStorage.getItem('ts');
            let { refreshZone } = state;
            const { municipio, cp, persist, zone, businessZones, } = action.data;
            let { x = '', mobile = 'undefined', maybeChange } = action.data;
            if (currentPersisted && currentPersisted.geo && currentPersisted.geo.x && x === '') {
                x = currentPersisted.geo.x;
            }
            if (currentPersisted && currentPersisted.geo && currentPersisted.geo.mobile && currentPersisted.geo.mobile !== 'undefined') {
                mobile = currentPersisted.geo.mobile;
            }
            let municipiosPosibles = [];
            if (businessZones) {
                municipiosPosibles = businessZones;
            }
            if (persist) {
                if (currentPersisted && !currentPersisted.ts) {
                    currentPersisted.ts = Date.now();
                }
                let modifiedPersisted = Object.assign(Object.assign({}, currentPersisted), { geo: {
                        cp,
                        municipio,
                        zone,
                        x,
                        mobile,
                    } });
                if (typeof maybeChange !== 'undefined') {
                    modifiedPersisted = Object.assign(Object.assign({}, modifiedPersisted), { geo: Object.assign(Object.assign({}, modifiedPersisted.geo), { maybeChange }) });
                }
                secureStorage.setItem('ts', modifiedPersisted);
            }
            if ((zone && zone !== initialState.zone)
                && (state.zone !== initialState.zone)
                && zone !== state.zone) {
                refreshZone = true;
            }
            return Object.assign(Object.assign({}, state), { refreshZone,
                cp,
                zone,
                municipio,
                municipiosPosibles,
                x,
                mobile });
        }
        case exports.types.SET_USER_PQ_INFO: {
            return Object.assign(Object.assign({}, state), { userPq: action.data.userPq, userFlags: action.data.userFlags });
        }
        case exports.types.SET_USER_PO_INFO: {
            return Object.assign(Object.assign({}, state), { userPo: action.data.userPo });
        }
        case exports.types.SET_USER_LG_INFO: {
            return Object.assign(Object.assign({}, state), { userLg: action.data.userLg });
        }
        case exports.types.SET_USER_RECOM: {
            const { userRecom } = action.data;
            return Object.assign(Object.assign({}, state), { userRecom });
        }
        case exports.types.SET_USER_COMPATIBILITIES: {
            const { userCompatibilities } = action.data;
            return Object.assign(Object.assign({}, state), { userCompatibilities });
        }
        case exports.types.SET_USER_BUNDLE: {
            const { userBundle } = action.data;
            return Object.assign(Object.assign({}, state), { userBundle });
        }
        case exports.types.SET_USER_DEFINITION: {
            const { userDefinitions } = action.data;
            return Object.assign(Object.assign({}, state), { userDefinitions });
        }
        case exports.types.SET_CP_MODAL_CLOSED: {
            return Object.assign(Object.assign({}, state), { cpModalClosed: action.flag });
        }
        case exports.types.SET_ZONE_REFRESH_FLAG: {
            return Object.assign(Object.assign({}, state), { refreshZone: action.flag });
        }
        case exports.types.SET_CONTEXT_DATA: {
            let newContext = Object.assign(Object.assign(Object.assign({}, state.context), action.payload), { environment: Object.assign(Object.assign({}, state.context.environment), action.payload.environment) });
            // full logado con idhash;
            let logged = "";
            logged = (newContext && (newContext.userIdPartyHash || newContext.userCUCFijoHash || newContext.userCUCMovilHash || newContext.userCUCPrepagoHash)) && newContext.userName && newContext.userType;
            // logado light, titular sin geo
            if (!logged && newContext && newContext.userName && newContext.userName === 'Hola') {
                logged = true;
            }
            return Object.assign(Object.assign({}, state), { rehidrate: state.rehidrate + 1, logged, context: Object.assign({}, newContext) });
        }
        case exports.types.SET_EDIT_MODE: {
            return Object.assign(Object.assign({}, state), { editMode: action.flag });
        }
        case exports.types.SET_SEND_C2C: {
            const { data } = action;
            const { status } = data;
            return Object.assign(Object.assign({}, state), { c2cState: status });
        }
        case exports.types.SET_CAMPAIGN_C2C: {
            const { data } = action;
            let { status: campaignState, info: campaignInfo } = state;
            if (data && data.status) {
                ({ status: campaignState } = data);
            }
            if (data && data.info) {
                ({ info: campaignInfo } = data);
            }
            return Object.assign(Object.assign({}, state), { campaignState,
                campaignInfo });
        }
        default:
            return state;
    }
}
exports.default = reducer;
//# sourceMappingURL=index.js.map